<template>
  <v-dialog v-model="dialog" max-width="350" @click:outside="close">
    <v-card
      v-if="processing"
      height="245"
      class="d-flex justify-center align-center"
    >
      <v-progress-circular
        indeterminate
        color="primary"
        class="loader"
      ></v-progress-circular>
    </v-card>

    <v-card v-else height="245" class="disable-bookie-dialog">
      <v-card-title class="headline">Disable Bookie</v-card-title>
      <v-card-text class="bookie-details">
        <div>
          <bookie-icon :bookie="bookie" :size="30"></bookie-icon>
          <span class="b-bookie"> {{ bookie }} ({{ bot }}) </span>
        </div>
        <v-form v-model="valid">
          <v-text-field
            label="Reason"
            v-model="reason"
            :rules="[rules.required]"
            filled
            required
          ></v-text-field>
        </v-form>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>

        <v-btn color="red darken-1" text @click="close">
          Cancel
        </v-btn>

        <v-btn color="green darken-1" :disabled="!valid" text @click="validate">
          Confirm
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import BookieIcon from "../components/BookieIcon";

export default {
  name: "DisableBookieDialog",
  data() {
    return {
      valid: false,
      reason: "",
      rules: {
        required: v => (v !== undefined && v !== null && v !== "") || "Required"
      }
    };
  },
  components: {
    BookieIcon
  },
  props: ["bot", "bookie", "dialog", "close", "confirm", "processing"],
  watch: {
    dialog(val) {
      if (!val) {
        this.reason = "";
        this.valid = false;
      }
    }
  },
  methods: {
    validate() {
      this.confirm(this.bot, this.bookie, this.reason);
    }
  }
};
</script>

<style lang="scss" scoped>
.b-bookie {
  font-size: 1.1em;
  display: inline-block;
}

div.form {
  margin-top: 20px;
}

.loader {
  margin: 0 auto;
  width: 100%;
}

.disable-bookie-dialog .v-card__text.bookie-details {
  padding-bottom: 0px;
}
</style>
